export const clickOutside = (el) => {
    const targetElementSelector = el.getAttribute('data-target');
    const targetElement = document.querySelector(targetElementSelector);
    const controlsOverlay = el.hasAttribute('data-controls-overlay');

    const handleClickOutside = (event) => {
        const isClickInside = targetElement.contains(event.target);

        if (!isClickInside) {
            targetElement.setAttribute('data-is-open', 'false');
            document.removeEventListener('click', handleClickOutside);
        }
        if (!isClickInside && controlsOverlay) {
            const htmlElement = document.querySelector('html');
            htmlElement.classList.remove('has-active-overlay');
        }
    };

    document.addEventListener('click', handleClickOutside);
};
